jQuery(document).ready(function($){
  if($('.m-search')[0]){
    $('.m-search__clear').click(function(e){
      e.preventDefault();

      const $form = $('.m-search__form');
      const $field = $('.m-field__input');

      $field.val('');
      $form.submit();
      
    });
  }
});